export const COSNETICS_AUTHENTICATION_ERROR_CODE =
  'COSNETICS_AUTHENTICATION_REQUIRED';
export const COSNETICS_AUTHENTICATION_ERROR_MESSAGE =
  'Your Cosnetics session has expired. Please sign in again.';

export class CosneticsAuthenticationError extends Error {
  readonly code = COSNETICS_AUTHENTICATION_ERROR_CODE;
  readonly status = 401;

  constructor() {
    super(COSNETICS_AUTHENTICATION_ERROR_MESSAGE);
    this.name = 'CosneticsAuthenticationError';
  }
}

export const isCosneticsAuthenticationError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;

  const candidate = error as {
    code?: string;
    message?: string;
    response?: { status?: number };
    status?: number;
  };

  return (
    candidate.code === COSNETICS_AUTHENTICATION_ERROR_CODE ||
    candidate.message === COSNETICS_AUTHENTICATION_ERROR_MESSAGE ||
    candidate.status === 401 ||
    candidate.response?.status === 401
  );
};
